import { commonRegx } from "xcommon-node/src/common/commonRegx";
import { EntityClaimRakurakuHistory } from "../../entity/EntityClaimRakurakuHistory";

export class DtoClaimRakurakuHistorysGetRes extends EntityClaimRakurakuHistory {
  public items: EntityClaimRakurakuHistory[]  = [];
}
